import Dexie from 'dexie';

export const db = new Dexie('syncmap');
db.version(1).stores({
  documents: '++documentId, title, documentTypeId, documentCategoryId, parentDocumentId, organizationId', // Primary key and indexed props
  geometries: '++geometryId, documentId', // Primary key and indexed props
  organizations: '++organizationId, title'
});
